export namespace OptionActions {
  export class GetOptions {
    static readonly type = '[Options] Get'
    constructor(public payload: { id: number }) { }
  }
  export class GetAvailableCutters {
    static readonly type = '[Options] Get Available Cutters'
    constructor(public payload: { id: number, sapnumber?: number }) { }
  }
  export class GetCutterGroupByOrder{
    static readonly type = '[Options] Get Cutter Group By Order'
    constructor(public payload: {id: number}) {}
  }
  export class GetPicklist{
    static readonly type = '[Options] Get Picklist'
    constructor(){}
  }
  export class GetBomLayout{
    static readonly type = '[Options] Get BOM Layout';
    constructor(public payload: { id: number }) { }
  }
}